var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 12, height: 8, xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M11.81 7.445c-.232.2-.581.176-.781-.055L6.152 1.66a.173.173 0 0 0-.261.001L.973 7.391a.553.553 0 1 1-.84-.72L5.756.12A.346.346 0 0 1 6.28.119l5.585 6.546c.2.23.175.58-.056.78Z", fill: "#999", fillRule: "nonzero" }));
export { SvgArrowUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuODEgNy40NDVjLS4yMzIuMi0uNTgxLjE3Ni0uNzgxLS4wNTVMNi4xNTIgMS42NmEuMTczLjE3MyAwIDAgMC0uMjYxLjAwMUwuOTczIDcuMzkxYS41NTMuNTUzIDAgMSAxLS44NC0uNzJMNS43NTYuMTJBLjM0Ni4zNDYgMCAwIDEgNi4yOC4xMTlsNS41ODUgNi41NDZjLjIuMjMuMTc1LjU4LS4wNTYuNzhaIiBmaWxsPSIjOTk5IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=";
